// extracted by mini-css-extract-plugin
module.exports = {"ageVerificationBlock":"CartItems_ageVerificationBlock__11BNC","alertBlock":"CartItems_alertBlock__G29Dg","cartItemWrapper":"CartItems_cartItemWrapper__K42ff"};